module.exports = __webpack_public_path__ + "static/media/xls.85c2738d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/scenes/Files/images/xls.svg
// module id = 607
// module chunks = 0